import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  preprendCartData: {
    product: 0,
    qty: 1,
    related_product: "",
    mcp_intervention_zipcode: "",
    mcp_intervention_slot: "",
    mcp_intervention_date: "",
    mcp_intervention_fake_slot: false,
    mcp_additional_sku: "",
    mcp_intervention_product: "",
    mcp_agency: "",
    need_cart_cleaning: false,
    standard_delivery_in_cart: false,
    installation_product_in_cart: false,
    delivery_only: false,
    is_exclusive: false,
    ajax: true,
    is_renting: false,
    is_financing: false,
    nb_months: "0",
    nb_months_financing: "0",
  },
  currentSelectedDelivery: "",
  tax_profile: {
    customer_tax_class_id: {},
    product_tax_class_id: {},
  },
  additionalInfo: 0,
};

export default {
  state,
  mutations,
  getters,
  actions,
};
